import randomstring from "randomstring";

const isEmpty = (value) => {
  if (value === null || value === undefined) {
    return true;
  }
  if (Array.isArray(value)) {
    return value.length === 0;
  } else if (typeof value === "object") {
    return Object.keys(value).length === 0 && value.constructor === Object;
  } else if (typeof value === "string") {
    return value.length === 0;
  } else if (typeof value === "number") {
    return value === 0;
  } else if (!value) {
    return true;
  }

  return false;
};

const createFormData = (url, id) => {
  const formData = new FormData();
  formData.append("url", url);
  formData.append("id", id);

  return formData;
};

const generateName = () => {
  return randomstring.generate({
    length: 10,
    charset: "alphanumeric",
  });
};

const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const formatDateTime = (timestamp) => {
  try {
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      day: "2-digit",
      month: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(new Date(timestamp));
  } catch (e) {
    console.log(e, timestamp);
  }
};

export {
  isEmpty,
  generateName,
  formatTimestamp,
  createFormData,
  formatDateTime,
};
